import React from 'react';

const UserAvatar = ({ user, size = 40, showBorder = false }) => {
    const styles = {
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'cover',
        border: showBorder ? '2px solid var(--primary-end)' : 'none',
        boxShadow: showBorder ? '0 0 10px rgba(236, 72, 153, 0.4)' : 'none',
        backgroundColor: 'var(--bg-panel)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: size * 0.4,
        fontWeight: 600,
        textTransform: 'uppercase'
    };

    const getInitials = () => {
        if (!user) return '?';
        if (user.name) return user.name.charAt(0);
        if (user.username) return user.username.charAt(0);
        if (user.email) return user.email.charAt(0);
        return '?';
    };

    if (user?.profile_pic) {
        return <img src={user.profile_pic} alt="profile" style={styles} />;
    }

    return (
        <div style={{ ...styles, background: 'linear-gradient(135deg, var(--primary-start), var(--primary-end))' }}>
            {getInitials()}
        </div>
    );
};

export default UserAvatar;
